import { ChatMessageTracesResponse, DeleteDocumentsResponse, DocumentInfoModel, DocumentsResponse, GetChatResponse, SessionResponse } from '../models/ChatTypes';
import { ComponentsData } from '../models/SidePanelTypes';
import { StructuredContent } from '../helpers/messageStreamHelper';
import { ChatMessageFeedback, InfoResponse, PersonaVersion, ProductivityGainResponse, TermsResponse, UpdateChatMetadataResponse } from '../models/types';
import { FileUploadStatus } from '../hooks/useFileUpload';

export const mockPersonaVersions: PersonaVersion[] = [
    {
        "version": "1.0.0",
        "date": "",
        "highlights": [],
        "revisions": [
            {
                "label": "1.0.0",
                "alpha": false,
                "beta": false,
                "build": 1,
                "documents": { "enabled": false },
                "version": "1.0.0"
            }
        ]
    }
];
export const mockGetInfoResponse: InfoResponse = {
    "user_id": "USER_ID",
    "personas": [
        {
            "type": "chat",
            "key": "dcs-pim-assistant",
            "route": "dcs",
            "title": "Climate Solutions Assistant",
            "description": "This AI assistant accelerates access to Climate Solutions' product information",
            "versions": mockPersonaVersions,
            //"version": "1.0.0"
        }
    ],
    "llm": [
        {
            "key": "gpt-35-turbo",
            "title": "Azure OpenAI GPT-3.5-Turbo",
            "description": "It is a very powerful tool that can be used to solve a variety of problems, including natural language processing tasks.",
            "sort": 0,
            "provider": "Open AI",
            "characterLimit": 1000,
        },
        {
            "key": "gpt-4",
            "title": "Azure OpenAI GPT-4",
            "description": "It is comparatively more powerful than GPT-3.5-Turbo, and It can solve even harder problems. It can also do things that GPT-3.5-Turbo can't, like write poems or scripts or translate languages.",
            "sort": 1,
            "provider": "Open AI",
            "characterLimit": 2000,
        },
        {
            "key": "gpt-4-32k",
            "title": "Azure OpenAI GPT-4-32k",
            "description": "Same as GPT-4 but supports more tokens.",
            "sort": 2,
            "provider": "Open AI",
            "characterLimit": 3000,
        }
    ],
    preferences: {
        personas_pinned: ["dcs-pim-assistant"],
        personas_disable_auto_pin: [''],
        prompts_pinned: [''],
    }
};

export const mockGetTermsResponse: TermsResponse = {
    "version": "152d84ff-6831-498d-d920-cbebe4d2a4d9",
    "title_text": "Danfoss AI Chatbot Platform Terms of Use",
    "text": "<p> </p>\n<p><strong>Danfoss AI Chatbot User Instruction</strong><br><br>This User Instruction is intended to inform Danfoss employees of the limitations and usage guidelines of the Danfoss AI Chatbot. The Danfoss AI Chatbot is available for Danfoss employees only on select basis. Please read this Instruction carefully before using the Danfoss AI Chatbot.</p>\n<p><br><br><strong>General Information</strong></p>\n<p>The Danfoss AI Chatbot is an automated function powered by Danfoss IT, and it is designed to provide information and assistance based on commercially available external AI chat models plus internal Danfoss information. The Danfoss AI Chatbot is a Danfoss tool made available to Danfoss’ employees as a work tool. The Danfoss AI Chatbot shall be used in Danfoss’ interest, in accordance with any Danfoss IT policies, and other applicable rules of Danfoss. Misuse of the Danfoss AI Chatbot may cause Danfoss to terminate your access.<br><br>The Danfoss AI Chatbot may display inaccurate, incomplete, or outdated information. We recommend that you to verify all the relevant information received. The Danfoss AI Chatbot does not reflect the opinion of Danfoss.<br><br>Be aware of the Danfoss AI Chatbot may display links or information from third-party websites. Such information may be copyright protected and subject to restrictions of use. You must always verify and check whether any information from Danfoss AI Chatbot can be used for any Danfoss related use.</p>\n<p><br><br><strong>User Responsibility</strong></p>\n<p>As responses are automated and can be based on both external publicly available information (internet) as well as internal Danfoss information (to the extent released for Chatbot use) – you should always exercise caution and use good judgment if relying, using, or acting upon the responses given by the Danfoss AI Chatbot.<br><br>The Danfoss AI Chatbot shall be used applying a respectful and constructive “dialogue”. As such, we kindly ask that you refrain from using any form of abusive or profane language.</p>\n<p><br><br><strong>Data safety and security</strong></p>\n<p>We prioritize the privacy and security of our users' information. When Danfoss allows access to internal Danfoss information – such access is granted in full compliance with the access restrictions in place for such information, i.e. in accordance with your own access rights in Danfoss. Be aware that chatbot conversations (questions and responses) may be reviewed by our content team to improve results. While the Danfoss AI Chatbot retains logs of these conversations for 30 days, this data is not used to train or be available to external AI models.<br><br><strong><u>Please do not share any personal information, including but not limited to your full name, address, social security number, financial details, or any other personally identifiable information. In particular, we strongly advise against sharing personal sensitive information, such as information on your health, race, or other personal characteristics.</u></strong> This is to ensure your privacy and security. <strong><u>If personal information is nevertheless shared by you or personal information is part of a response, kindly note that you can always delete the conversations in an easy manner.</u></strong> Also note that processing of conversations with such personal information is processed only on this Danfoss AI Chatbot platform to enable the conversations, and is only accessible to necessary IT personnel to manage, operate and to improve function and performance of the Danfoss AI Chatbot.<br><br>By using our Danfoss AI chatbot, you agree to have read and understood this User Instruction.</p>",
    "culture": "en"
};

export const mockGetChatResponse: GetChatResponse[] = [
    //   Base Response
    {
        "session": {
            "user_id": "USER_ID",
            "session_id": "base-session-id",
            "subject": "Base session",
            "created": "2023-12-18T14:09:16.985223Z",
            "updated": "2023-12-20T11:38:15.708899Z",
            "llm": "gpt-35-turbo",
            "productivity_gain": 19,
            "documents": []
        },
        "messages": [
            {
                "id": "e63cf9d2-1d75-44c8-b89f-ba3a99f47a1f",
                "created": "2023-12-18T14:09:17.520317Z",
                "type": "human",
                "content": "How can I mock this chat?"
            },
            {
                "id": "1b68195a-bda3-4de4-881e-087770448cb7",
                "created": "2023-12-18T14:09:17.544800Z",
                "type": "ai",
                "content": "Please create a new chat response at __mockGetChatResponse__ in mockData, and map it with history __mockGetChatsResponse__ response via __session_id__!"
            },
        ]
    }, {
        "session": {
            "user_id": "USER_ID",
            "session_id": "test-tables-session-id",
            "subject": "Tables",
            "created": "2023-12-18T14:09:16.985223Z",
            "updated": "2023-12-20T11:38:15.708899Z",
            "llm": "gpt-35-turbo",
            "productivity_gain": 19,
            "documents": []
        },
        "messages": [
            {
                "id": "a89fafef-dee9-437c-89fa-08a4e16f0851",
                "created": "2023-12-18T22:05:41.432714Z",
                "type": "human",
                "content": "Can you make a table of the top 10 most cars in countries?"
            },
            {
                "id": "e6bc155c-91f2-4c08-8569-0953f32c2f65",
                "created": "2023-12-18T22:05:41.456209Z",
                "type": "ai",
                "content": "Certainly! Here is a table showcasing the top 10 countries with the highest number of cars, based on data from 2020:\n\n| Rank | Country           | Number of Cars (in millions) |\n|------|-------------------|------------------------------|\n| 1    | United States     | 276.1                        |\n| 2    | China             | 270.4                        |\n| 3    | Japan             | 78.5                         |\n| 4    | Germany           | 47.7                         |\n| 5    | India             | 39.2                         |\n| 6    | Brazil            | 38.2                         |\n| 7    | France            | 32.2                         |\n| 8    | United Kingdom    | 31.5                         |\n| 9    | Italy             | 30.8                         |\n| 10   | Canada            | 23.7                         |\n\nPlease note that these numbers are approximate and may vary slightly depending on different sources and methodologies used for data collection."
            },
            {
                "id": "2a519ca8-2867-434b-a381-0c5bb76719b5",
                "created": "2023-12-18T22:06:01.915797Z",
                "type": "human",
                "content": "Extend table with more columns, like population, cars per capita, GDP, etc."
            },
            {
                "id": "9e1d1097-c494-47b0-9c53-5b244000ace7",
                "created": "2023-12-18T22:06:01.939972Z",
                "type": "ai",
                "context": {
                    sources: [
                        { "source": 'Source 1', "url": 'https://google.com?q=1', "snippet": 'Source 1 - snippet 1' },
                        { "source": 'Source 1', "url": 'https://google.com?q=2', "snippet": 'Source 1 - snippet 2 \nA longer source description' },
                        { "source": 'Source 1', "url": 'https://google.com?q=3', "snippet": 'Source 1 - snippet 3 An extra long source description that will use all available horizontal space and force the text to break out of the defined width and wrap' },
                        { "source": 'Source 2', "url": 'https://google.com?q=4', "snippet": 'Source 2' },
                    ]
                },
                "content": "Certainly! Here's an updated table with a few additional interesting columns:\n\n| Rank | Country           | Number of Cars (in millions) | Population (in millions) | Cars per Capita | GDP (in trillion USD) | Cars per GDP (per trillion USD) |\n|------|-------------------|------------------------------|-------------------------|-----------------|-----------------------|---------------------------------|\n| 1    | United States     | 276.1                        | 331.0                   | 0.835           | 21.43                 | 12.89                           |\n| 2    | China             | 270.4                        | 1,439.3                 | 0.188           | 14.34                 | 18.86                           |\n| 3    | Japan             | 78.5                         | 126.5                   | 0.620           | 5.08                  | 15.43                           |\n| 4    | Germany           | 47.7                         | 83.8                    | 0.569           | 3.86                  | 12.36                           |\n| 5    | India             | 39.2                         | 1,366.4                 | 0.029           | 2.87                  | 13.64                           |\n| 6    | Brazil            | 38.2                         | 211.0                   | 0.181           | 1.43                  | 26.72                           |\n| 7    | France            | 32.2                         | 67.1                    | 0.480           | 2.71                  | 11.89                           |\n| 8    | United Kingdom    | 31.5                         | 66.8                    | 0.472           | 2.83                  | 11.12                           |\n| 9    | Italy             | 30.8                         | 60.4                    | 0.509           | 2.00                  | 15.40                           |\n| 10   | Canada            | 23.7                         | 37.6                    | 0.631           | 1.64                  | 14.45                           |\n\nThe \"Population\" column represents the estimated population of each country, the \"Cars per Capita\" column shows the number of cars per person, the \"GDP\" column represents the Gross Domestic Product of each country, and the \"Cars per GDP\" column shows the number of cars per trillion USD of GDP."
            }
        ]
    }, {
        'session': {
            'user_id': 'USER_ID',
            'session_id': 'side-panel-session-id',
            'subject': 'Side panel test',
            'created': '2023-12-18T14:09:16.985223Z',
            'updated': '2023-12-20T11:38:15.708899Z',
            'llm': 'gpt-35-turbo',
            'productivity_gain': null,
            "documents": []
        },
        'messages': [
            {
                'id': 'e63cf9d2-1d75-44c8-b89f-a3a99f47Da1f',
                'created': '2023-12-18T14:09:17.520317Z',
                'type': 'human',
                'content': 'Show side panel for Data display'
            },
            {
                'id': '1b68195a-bda3-4de4-881e-087D70441cb7',
                'created': '2023-12-18T14:09:17.544800Z',
                'type': 'ai',
                'content': 'See the __data__ side panel with attribute set to: _[attribute-id]_. [Invoke side panel](/chat/side-panel-session-id#data-attribute-id)'
            },
            {
                'id': 'e63cf9d2-1d75-44c8-b89f-a3a99f47Da1a',
                'created': '2023-12-18T14:09:17.520317Z',
                'type': 'human',
                'content': 'Show side panel for PDF viewer display'
            },
            {
                'id': '1b68195a-bda3-4d34-881e-087D70448cb7',
                'created': '2023-12-18T14:09:17.544800Z',
                'type': 'ai',
                'content': 'See the __pdf__ side panel with attribute set to: https://assets.danfoss.com/documents/253928/AI170686478826en-010804.pdf'
            },
            {
                'id': 'e63cf9d2-1d75-44c8-b89f-a3a99f47Dasf',
                'created': '2023-12-18T14:09:17.520317Z',
                'type': 'human',
                'content': 'Show side panel for Trace viewer display'
            },
            {
                'id': '1b68195a-bda3-4de4-881e-087D73444cb7',
                'created': '2023-12-18T14:09:17.544800Z',
                'type': 'ai',
                'content': 'See the __trace__ side panel: [Invoke side panel](/chat/side-panel-session-id#trace-attribute-id)'
            },
            {
                'id': 'e63cf9d2-1d75-44c8-b89f-a3a99f47Dadf',
                'created': '2023-12-18T14:09:17.520317Z',
                'type': 'human',
                'content': 'Show side panel for Document upload'
            },
            {
                'id': '1b68195a-bda3-4de4-881e-087D704483b7',
                'created': '2023-12-18T14:09:17.544800Z',
                'type': 'ai',
                'content': 'See the __document upload__ side panel with attribute set to: _[upload]_. [Invoke side panel](/chat/side-panel-session-id#documents-upload)'
            },
        ]
    }, {
        "session": {
            "user_id": "USER_ID",
            "session_id": "trusted-html-session-id",
            "subject": "Structured Content Model",
            "created": "2023-12-18T14:09:16.985223Z",
            "updated": "2023-12-20T11:38:15.708899Z",
            "llm": "gpt-35-turbo",
            "productivity_gain": null,
            "documents": []
        },
        "messages": [
            {
                "id": "e63cf9d2-1d75-44c8-b89f-a3a99f47da1f",
                "created": "2023-12-18T14:09:17.520317Z",
                "type": "human",
                "content": "Show side trusted HTML content"
            },
            {
                "id": "1b68195a-bda3-4de4-881e-087d70448cb7",
                "created": "2023-12-18T14:09:17.544800Z",
                "type": "ai",
                "content": `<${StructuredContent.TrustedHtmlContent}>Trusted HTML content, with html: <b>sss</b></${StructuredContent.TrustedHtmlContent}>`
            }
        ],
    }];

export const mockGetChatsResponse: SessionResponse[] = [
    {
        'user_id': 'USER_ID',
        'session_id': 'base-session-id',
        'subject': 'Base session',
        'created': '2023-12-18T14:09:16.985223Z',
        'updated': '2023-12-20T11:38:15.708899Z',
        'llm': 'gpt-35-turbo',
        'productivity_gain': 19,
        "documents": []
    },
    {
        "user_id": "USER_ID",
        "session_id": "test-tables-session-id",
        "subject": "Tables",
        "created": "2023-12-18T14:09:16.985223Z",
        "updated": "2023-12-20T11:38:15.708899Z",
        "llm": "gpt-35-turbo",
        "productivity_gain": 19,
        "documents": []
    },
    {
        "user_id": "USER_ID",
        "session_id": "trusted-html-session-id",
        "subject": "Structured Content Model",
        "created": "2023-12-18T14:09:16.985223Z",
        "updated": "2023-12-20T11:38:15.708899Z",
        "llm": "gpt-35-turbo",
        "productivity_gain": 19,
        "documents": []
    },
    {
        "user_id": "USER_ID",
        "session_id": "side-panel-session-id",
        "subject": "Side panel test",
        "created": "2023-12-18T14:09:16.985223Z",
        "updated": "2023-12-20T11:38:15.708899Z",
        "llm": "gpt-35-turbo",
        "productivity_gain": 19,
        "documents": []
    },
    // {
    //     "user_id": "USER_ID",
    //     "session_id": "240f839d-496f-456c-93c0-62433cdbc1d8",
    //     "subject": "Help me with this",
    //     "created": "2023-12-20T09:26:59.610634Z",
    //     "updated": "2023-12-20T09:27:46.698314Z",
    //     "llm": "gpt-35-turbo",
    //     "productivity_gain": null,
    // },
];

export const mockCreateChatResponse: SessionResponse = {
    "user_id": "USER_ID",
    "session_id": "240f839d-496f-456c-93c0-62433cdbc1d8",
    "subject": "test",
    "created": "2023-12-20T09:26:59.610634",
    "updated": "2023-12-20T09:26:59.610637",
    "llm": "gpt-35-turbo",
    "documents": [],
    productivity_gain: null
};

export const mockUpdateChatMetadataResponse: UpdateChatMetadataResponse = { "success": true, "message": "" };

export const mockDocumentMetadataResponse: DocumentInfoModel = {
    id: "987e6543-a21b-32c1-d543-426614174111",
    user: "user123",
    format: "pdf",
    type: "report",
    size: 1048576, // 1 MB in bytes
    modified: "2024-09-25T12:34:56Z", // ISO format for the last modified time
    display: {
        name: "Quarterly Report",
        description: "Q2 2024 Financial Summary"
    },
    created: "2024-10-02T19:00:21Z",
};

export const mockDocumentsResponse: DocumentsResponse = {
    "documents": {
        "z8nglvf0ar": {
            "id": "z8nglvf0ar",
            "user": "1870c23d-bfdb-428f-8cac-f0065cdac0ed",
            "display": {
                "name": "Screenshot 2024-09-10 at 12.28.08.png",
                "description": undefined
            },
            "format": ".png",
            "type": "image/png",
            "size": 129574,
            "modified": "2024-10-02T19:00:21Z",
            "state": {
                "status": FileUploadStatus.Ready
            },
            "created": "2024-10-02T19:00:21Z",
        },
        "suawa0zx6l": {
            "id": "suawa0zx6l",
            "user": "1870c23d-bfdb-428f-8cac-f0065cdac0ed",
            "display": {
                "name": "Screenshot 2024-09-12 at 10.29.11.png",
                "description": undefined
            },
            "format": ".png",
            "type": "image/png",
            "size": 118388,
            "modified": "2024-10-02T18:31:05Z",
            "state": {
                "status": FileUploadStatus.Ready
            },
            "created": "2024-10-02T19:00:21Z",
        }
    },
    "errors": {}
};

export const mockDeleteDocumentResponse: DeleteDocumentsResponse = {
    "delete_document_ids": ["roame1hqs3"],
    "errors": {
        "roame1hqs3": "There is no current event loop in thread 'ThreadPoolExecutor-1_0'."
    }
};

export const mockChatMessageFeedback: ChatMessageFeedback = { message_id: '32423423432432', vote: 0, comment: null };


const md = "" +
    "```json" +
    "" +
    `
${JSON.stringify({ processId: "", status: "", message: "", error: null })}
` +
    "```";

export const mockChatMessageInsights: ChatMessageTracesResponse = {
    traces: [
        {
            headline: "Performing semantics analysis..",
            description: "The LLM looks up the keywords and finds their meaning in the internal context of Danfoss",
            result: "Matched 3 products and 4 categories",
        },
        {
            headline: "Retrieving documents metadata..",
            description: "The LLM retrieves metadata of the documents related to the keywords",
            result: "Matched 5 documents",
            input: md,
        },
        {
            headline: "Preparing PIM knowledge graph quires..",
            description: "The LLM prepares the quires to retrieve the PIM data",
            result: "Matched 2 products and 3 categories",
            output: md
        },
        {
            headline: "Retrieving PIM data..",
            description: "The LLM retrieves the PIM data based on the quires",
            result: "Matched 1 product and 2 categories",
            artifact: md,
        },
        {
            headline: "Retrieving DAM data..",
            description: "The LLM retrieves the DAM data based on the quires",
            result: "Matched 1 product and 2 categories",
            input: md,
            output: md
        },
        {
            headline: "Retrieving DAM data..",
            description: "The LLM retrieves the DAM data based on the quires",
            result: "Matched 1 product and 2 categories",
            input: md,
            output: md,
            artifact: md,
        },
    ]
};


export const mockSubmitProductivityGainResponse: ProductivityGainResponse = { message: 'Productivity gain submitted successfully', success: true };

export const mockPromptResponseDefault = `Sure! Here's a mind-blowing fact: Did you know that there are more stars in the universe than there are grains of sand on all the beaches on Earth? It's estimated that there are about 10 sextillion (10^22) stars in the observable universe, while there are roughly 7.5 quintillion (7.5 x 10^18) grains of sand on Earth. This just goes to show the vastness and awe-inspiring nature of our universe!`;
export const mockPromptResponseWithSysMsg = `<SystemMessage>{
    "state": "Formulating query.."
}</SystemMessage>
<SystemMessage>{
    "state": "Loading context.."
}</SystemMessage>

This is the start of the GPT message

New line
## Testing headline

This is a test of the GPT message

<ResponseContext>[
        {
            "label": "Some source 1",
            "id": "id-1",
            "content": "Content 1: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        },
        {
            "label": "Some source 2",
            "id": "id-2",
            "content": "Content 2: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
    ]
</ResponseContext>`;

// Below prompt response will crash the markdown, if no link_close renderer rule is defined for markdownit
// export const mockPromptResponse = `Here is a comparison of the two products, 068U2490 and 068U3983, in a table format:\n\n| Attribute | 068U2490 | 068U3983 |\n|-----------|----------|----------|\n| Product (code number) | 187B1500 | 013G4179 |\n| Segment | DHS | DHS |\n| Line | District Energy Controls (08) | Mechanical TRV (03) |\n| Group | SCADA solutions | Products for design radiators |\n| Type | DECS | Accessories for Design Products |\n| Headline | DECS | Accessories for Design Products |\n| Description | DECS | O-ring for VHX angle and VHX stay bolt (2 pcs 22.3x2.4; 1 pcs 18.0x3.0) |\n| Store URL | [Link](https://store.danfoss.com/p/187B1500) | [Link](https://store.danfoss.com/p/013G4179) |\n| Number of controllers [Max] | 1200 | - |\n| Supported controllers | ECL Comfort 310, OPR0010, OPR0020 | - |\n| In scope of WEEE and contain batteries | No | No |\n| Monitoring and visualization | Restriction window for filtering certain temperature ranges; Sums of the total amount of taken off heat; Input of the qualifying date for energy consumption meters; Sums of the instantaneous power; Statistical analysis of the boiler house data (graphical and tabular); Overview of all controllers; Display and evaluation of different billing rates; Display of the number of controllers that are used for power calculation; Overview of the individual heat meter data per customer; Display of the sums of the amounts of heat between two or more parts of network; Display the instantaneous power of the overall network and or multiple parts of network; Possibility of visualization and control of various freely definable parts of network; Statistical analysis per customer for all setpoints, actual values ​​and energy consumption meters (graphical and tabular); Displays the number of currently reachable energy consumption meters and controllers; Qm-evaluation per boiler house, network and customer equipment can be evaluated; Flow management with analysis options per customer; Display of current efficiency; Sort the customer overview by name, inst. power, inst. flow rates, flow and return temperatures, prim. tank temperatures etc.; Display of the settlement or city plan and direct selection of the customer; Sum of the sensed heat quantity of the current season; Complete hydraulic representation of the controlled circuits; Input of customers, arithmetic unit numbers and account numbers per customer for external billing file; Configuration of the qualifying date by the SCADA system | - |\n| Application key compatibility | P330, A337, A347, A367, A266, A230, A260, A377 | - |\n| User authorization levels | full access, limited access, read-only access | - |\n| Control | Overview of the settings of installed pressure transmitters and leakage warning devices in the network; Overview and changeability of all controller setpoints and configuration values; Entering a min. and max. heat consumption per electronic controller per day; Overview and changeability of all current switch settings (Mode, remote controls and day/night potentiometer per circuit); Overview and variability of holiday circulation and boiler load times as well as Legionella heating times | - |\n| Data logging and import/export | Creating a backup file with all the controller parameters for all customer which are connected to the SCADA system; Microsoft independent data storage; Readout of the energy consumption meter month storage and log storage by the SCADA system; Exporting customer data, setpoints, historical and present data to other file formats; Logging of all changes of setpoints (with date, time, user, old value, new value); Logging of user login | - |\n| User interface | Use of freely scalable SVG graphics guarantees, hardware independent, always the highest possible resolution; Automatic configuration of the customer system on the host computer if connected to the SCADA System | - |\n| Data communication protocols | Modbus | - |\n| Alarming | Logging of alarm acknowledgment; Alarms are logged with date and time stamp; Logging of all alarms (sensor break, error of energy consumption meter, communication error) | - |\n| Data communication | The electronic controller can be enabled via the remote but also locked; All data must be bidirectional interchangeable; Controller program updates as well as heat meter protocol changes must be carried out centrally via the bus system; Use of OPC UA Server (Microsoft independent); The electronic controller can be reconfigured by the SCADA system; All energy consumption meters into the boiler house must be includable via M-Bus in the visualization; Differential pressure transmitters in the network can be read and send to a serial interface (0-10 V / 4-20 mA) and displayed; Monitoring of a leakage warning device connected to a free input port at the electronic controller; Central update capability for all the connected electronic controller via the network; End user errors are detected and can be corrected using the SCADA system; Central synchronization of date and time with the SCADA system | - |\n| Data communication interfaces | Ethernet, RS485, LON | - |\n| Graphical User interface | Web-based | - |\n| Documents | [Data sheet](https://assets.danfoss.com/documents/latest/70752/AI091586468964en-010501.pdf), [Operating guide](https://assets.danfoss.com/documents/latest/160000/AQ173386472022en-010501.pdf), [Operating guide](https://assets.danfoss.com/documents/latest/206108/AQ074886472234en-010602.pdf), [Data sheet](https://assets.danfoss.com/documents/latest/72408/AI124286468215en-010601.pdf), [Operating guide](https://assets.danfoss.com/documents/latest/159855/AQ091586468999en-010501.pdf), [Operating guide](https://assets.danfoss.com/documents/latest/159944/AQ128386472851en-010301.pdf), [User guide](https://assets.danfoss.com/documents/latest/160228/BC091586469017en-020402.pdf), [Data sheet](https://assets.danfoss.com/documents/latest/69384/AI063286468365en-010301.pdf), [Operating guide](https://assets.danfoss.com/documents/latest/159938/AQ091586469025en-010501.pdf), [Data sheet](https://assets.danfoss.com/documents/latest/189450/AI150386468396en-010801.pdf), [Operating guide](https://assets.danfoss.com/documents/latest/159847/AQ085786472248en-010301.pdf), [Case story](https://assets.danfoss.com/documents/latest/98631/AE135486456485en-010201.pdf), [Operating guide](https://assets.danfoss.com/documents/latest/159824/AQ070386470176en-010301.pdf) | - |`;

export const mockPromptResponseWithError = `<PromptErrorInformation>{"message":"1 The response was filtered due to the prompt triggering Azure OpenAI's content management policy. Please modify your prompt and retry. To learn more about our content filtering policies please read our documentation: https://go.microsoft.com/fwlink/?linkid=2198766","code":"content_filter"}</PromptErrorInformation>

Hello there

<PromptErrorInformation>{"message":"2 The response was filtered due to the prompt triggering Azure OpenAI's content management policy. Please modify your prompt and retry. To learn more about our content filtering policies please read our documentation: https://go.microsoft.com/fwlink/?linkid=2198766","code":"content_filter"}</PromptErrorInformation>`;

export const mockChatMessageWithTable = `Here are some datasheets for Danfoss scroll compressors:

| Document Name | Document Number | Link |
|---------------|-----------------|------|
| Scroll compressors DCH290 | AB380318911731en-CN0101 | [Download](https://assets.danfoss.com/documents/latest/211606/AB380318911731en-CN0101.pdf) |
| Spare parts and accessories Danfoss Commercial Compressors for hermetic reciprocating and scroll compressors (AC/HP & REF) | AF200886436047en-000901 | [Download](https://assets.danfoss.com/documents/latest/256012/AF200886436047en-000901.pdf) |
| Scroll compressors CH290 and CH485 | AB236986442743en-000501 | [Download](https://assets.danfoss.com/documents/latest/208237/AB236986442743en-000501.pdf) |
| Scroll compressors CH290 and CH485 | AB236986442743en-IN0501 | [Download](https://assets.danfoss.com/documents/latest/208240/AB236986442743en-IN0501.pdf) |
| Guideline - Danfoss scroll compressors CXH140 - single and manifold installation | AB230086438777en-000501 | [Download](https://assets.danfoss.com/documents/latest/89965/AB230086438777en-000501.pdf) |
| Guideline Danfoss scroll compressors DCJ 091-121 - GB - SI | AB216786428116en-000301 | [Download](https://assets.danfoss.com/documents/latest/89852/AB216786428116en-000301.pdf) |
| Danfoss scrolls, H/DCJ series with multi refrigerants Residential and light commercial | AB470335763668en-000101 | [Download](https://assets.danfoss.com/documents/latest/374240/AB470335763668en-000101.pdf) |
| 2024 Quick Select Guide - Refrigeration and Air Conditioning Components | AF371473195263en-010501 | [Download](https://assets.danfoss.com/documents/latest/368698/AF371473195263en-010501.pdf) |

This is a partial list. If you need more datasheets or specific information, please let me know!
`;
export const mockPromptResponse = mockChatMessageWithTable;

export const sidePanelDataMock: ComponentsData = [
    {
        component: "hero",
        properties: {
            title: "Product: 027H1020",
            images: ["https://assets.danfoss.com/photos/preview/113089/ID107325945075-0101_preview.jpg", 'https://assets.danfoss.com/photos/preview/113089/ID107325945075-0101_preview.jpg'],
            subtitle: "Motor operated valve, ICM 20-A, Steel",
            text: "Outlet connection size [mm]: 25.0, Inlet connection size [mm]: 25.0, Inlet connection type: Butt weld, Outlet connection type: Butt weld, Kv value [m³/h]: 0.600",
            code: "027H1020",
            tags: ["Attribute 1", "Tag 2", "Product 3", "Spare parts 4"],
            externalLink: [{ text: 'Donfoss', url: "https://www.danfoss.com" }, { text: 'Store Danfoss', url: 'https://store.danfoss.com' }]
        },
        children: undefined
    },
    {
        component: 'section',
        properties: {
            title: "Motor operated valve, ICM 20-A, Steel",
            subtitle: 'Section subtitle',
            text: '__Outlet__ connection size [mm]: 25.0, Inlet connection size [mm]: 25.0, Inlet connection type: Butt weld, Outlet connection type: Butt weld, Kv value [m³/h]: 0.600',
        },
        children: undefined
    },
    {
        component: "accordion",
        properties: {
            title: "Spare parts",
            subtitle: "View spare parts of 027H1020",
            open: true,
        },
        children: [
            {
                component: "table",
                properties: {
                    title: "",
                    headers: [{
                        name: "Code number",
                        sortable: true,
                        searchable: true,
                        filterable: false,
                    },
                    {
                        name: "Description",
                        filterable: false,
                    }],
                    rows: [[
                        "027H1180",
                        "Function module, ICM 20-A, Steel"
                    ], [
                        "027H1190",
                        "Spare part, ICM 20-B / 20-C; ICM 20-A / 20-A33, Service kit ICM 20"
                    ]]
                },
                children: undefined
            }
        ]
    },
    {
        component: "table",
        properties: {
            title: "Documents",
            headers: [{
                name: "Document Type",
                sortable: true,
                filterable: false,
            }, {
                name: "Description",
                filterable: false,
            }, {
                name: "Actions",
                filterable: false,
            }],
            rows: [
                [
                    "Catalog",
                    {
                        text: "Industrial refrigeration - Spare parts and accessories",
                        url: "https://assets.danfoss.com/documents/408387/AF249786497394en-001603.pdf"
                    },
                    {
                        icon: "pdf",
                        url: "https://assets.danfoss.com/documents/408387/AF249786497394en-001603.pdf"
                    }
                ],
                [
                    "Asset",
                    {
                        text: "Industrial refrigeration - Spare parts and accessories",
                        url: "https://assets.danfoss.com/documents/408387/AF249786497394en-001603.pdf"
                    },
                    {
                        icon: "download",
                        url: "https://assets.danfoss.com/documents/408387/AF249786497394en-001603.pdf"
                    }
                ],
                [
                    "Spare part",
                    {
                        text: "__Industrial refrigeration - Spare parts and accessories__",
                        url: "https://assets.danfoss.com/documents/408387/AF249786497394en-001603.pdf"
                    },
                    {
                        icon: "new-tab",
                        url: "https://assets.danfoss.com/documents/408387/AF249786497394en-001603.pdf"
                    }
                ]
            ]
        },
        children: undefined
    },
    {
        component: 'section',
        properties: {
            title: "Motor operated valve, ICM 20-A, Steel",
            subtitle: 'Section subtitle',
            text: '__Outlet__ connection size [mm]: 25.0, Inlet connection size [mm]: 25.0, Inlet connection type: Butt weld, Outlet connection type: Butt weld, Kv value [m³/h]: 0.600',
        },
        children: [
            {
                component: 'accordion',
                properties: {
                    title: 'Accordion title',
                    subtitle: 'Accordion subtitle',
                    open: false
                },
                children: [
                    {
                        component: 'table',
                        properties: {
                            title: 'Json Placeholder',
                            headers: [
                                {
                                    name: 'Id',
                                    // searchable: true,
                                    filterable: false,
                                    filterConfig: {
                                        type: 'select',
                                        initialInput: ['1'],
                                        // 1 Initial object loading
                                        // 2 Lazy loading
                                        // 3 Dynamic Data Loading (not implemented)
                                        //     options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15']
                                    }
                                },
                                {
                                    name: 'Title',
                                    sortable: true,
                                    searchable: true,
                                },
                            ],
                            rows: undefined,
                            source: '- https://jsonplaceholder.typicode.com/posts' //'https://jsonplaceholder.typicode.com/comments?postId=',//'https://example.com/table-data',
                        },
                        children: undefined
                    }
                ]
            },
            {
                component: 'table',
                properties: {
                    title: 'Table title',
                    headers: [{
                        name: 'Header 1',
                        sortable: true,
                        filterable: false
                    },
                    {
                        name: 'Header 2'
                    }],
                    rows: [
                        ['Cell 1', 'Cell 2'],
                        ['Cell 3', 'Cell 4']
                    ]
                },
                children: []
            }
        ]
    },
];

export const mockDynamicData = {
    rows: [
        ['1', 'Row 1'],
        ['2', 'Row 2'],
        ['3', 'Row 3'],
        ['4', 'Row 4'],
        ['5', 'Row 5'],
        ['6', 'Row 6'],
        ['7', 'Row 7'],
        ['8', 'Row 8'],
        ['9', 'Row 9'],
        ['10', 'Row 10'],
    ],
    count: 100,
};
